import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconCalendarDown,
  IconCalendarUp,
  IconFileExport,
  IconFileSearch,
  IconNumbers,
  IconPrinter,
  IconSearch,
  IconTimeDuration15,
  IconTruckDelivery,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isJSON } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { green, olive_green, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import ConfirmInfoGHTK from "./ConfirmInfoGHTK";
import {
  getShippingVendorText,
  getTextStatus,
  warehouseStatus,
} from "./helper";
import { printGhtkLabel } from "./printGhtkLabel";
import { useTableFillScreen } from "./useTableFillScreen";

// Định nghĩa kiểu dữ liệu đơn hàng đối tác
interface GHTKOrder {
  orderCode: string; // Mã đơn hàng nội bộ
  partnerOrderCode: string; // Mã đơn bên đối tác
}

const GHTK = ({ toolbar }: { toolbar: HTMLElement | null }) => {
  const navigate = useNavigate();
  const [data, setData] = useState<GHTKOrder[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [rowCount, setRowCount] = useState(0);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //dataExportExcel
  const [dataExportExcel, setDataExportExcel] = useState<any[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    [],
  );
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  // Thêm state cho filter ngày xuất kho và trạng thái đơn hàng
  const [filterOwDate, setFilterOwDate] = useState<Date | null>(
    _searchJson && checkedPinSearch ? _searchJson?.filterOwDate : null,
  );
  const [filterOrderStatus, setFilterOrderStatus] = useState<string>("");

  // Danh sách trạng thái đơn hàng mẫu
  const orderStatusOptions = [
    { value: "", label: "Tất cả" },
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
    // ...bổ sung thêm nếu cần
  ];

  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);

  const searchForm = useForm({
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      OrderNumber:
        _searchJson && checkedPinSearch ? _searchJson?.OrderNumber : "",
      Phone: _searchJson && checkedPinSearch ? _searchJson?.Phone : "",
      FinishDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.FinishDate
          : (null as Date | null),
      StartDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.StartDate
          : new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1),
              ).getTime() +
                7 * 60 * 60 * 1000,
            )?.toISOString(),
      EndDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.EndDate
          : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
      InvId: _searchJson && checkedPinSearch ? _searchJson?.InvId || "" : "",
      CodeSal:
        _searchJson && checkedPinSearch ? _searchJson?.CodeSal || "" : "",
    },
  });

  // Định nghĩa columns cho MantineReactTable
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => handleCheckView(row)}
            >
              {renderedCellValue === null ? "KHÔNG HỢP LỆ" : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        // accessorKey: "attribute12",
        accessorKey: "pushStatus",
        header: "Trạng thái đẩy đơn",
        Cell: ({ row }) => {
          if (row?.original?.attribute3 === "DA_XUAT") {
            try {
              const attr1 = row?.original?.attribute1;
              if (attr1) {
                const data = JSON.parse(attr1);
                if (data.sharedLink) {
                  return (
                    <Flex align="center" gap={8}>
                      <Badge color="green" variant="light">
                        Đã đẩy
                      </Badge>
                    </Flex>
                  );
                } else {
                  // Đẩy đơn lỗi: màu đỏ
                  return (
                    <Badge color="red" variant="light">
                      Đẩy đơn lỗi
                    </Badge>
                  );
                }
              }
            } catch (e) {
              // Đẩy đơn lỗi: màu đỏ
              return (
                <Badge color="red" variant="light">
                  Đẩy đơn lỗi
                </Badge>
              );
            }
          }
          // Chưa đẩy: màu xám
          return (
            <Badge color="gray" variant="light">
              Chưa đẩy
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute64",
        header: "Trạng thái giao hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              color={
                renderedCellValue === "5"
                  ? "green"
                  : renderedCellValue === "-1"
                    ? "red"
                    : "gray"
              }
              variant="light"
            >
              {renderedCellValue === "5"
                ? "Hoàn thành"
                : renderedCellValue === "-1"
                  ? "Đóng"
                  : ""}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },

      {
        accessorKey: "invOrgName",
        header: "Kho hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{`[${row.original.invOrgCode}] ${row.original.invOrgName}`}</>
        ),
      },
      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        enableColumnFilter: false,
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 120,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const actions = [];
          const attr1 = row.original.attribute1 || null;
          const sharedLink =
            row.original.attribute1 && isJSON(row.original.attribute1)
              ? JSON.parse(attr1)?.sharedLink
              : null;

          // Đẩy lại GHTK
          if (
            row?.original?.shipingVendor === "Giao hàng tiết kiệm" &&
            row?.original?.orderStatus === "DON_HANG_HOAN_THANH" &&
            (row.original.attribute3 !== "DA_XUAT" || !sharedLink)
          ) {
            actions.push(
              <Tooltip label="Đẩy lại GHTK" key="push-ghtk">
                <ActionIcon
                  onClick={() => {
                    // handeOrderGHTK(row.original.orderNumber);
                    modalsConfirmInfo(row.original.orderNumber);
                  }}
                  variant="light"
                  aria-label="Settings"
                  color="green"
                >
                  <IconTruckDelivery size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>,
            );
          }
          // Thông tin giao vận (icon link)
          try {
            const attr1 = row?.original?.attribute1;
            if (attr1) {
              const data = JSON.parse(attr1);
              if (data.sharedLink) {
                actions.push(
                  <Tooltip label="Thông tin giao vận" key="tracking-link">
                    <ActionIcon
                      color="blue"
                      variant="light"
                      onClick={() => {
                        window.open(
                          `https://i.ghtk.vn/${data.sharedLink}`,
                          "_blank",
                        );
                      }}
                      aria-label="Thông tin giao vận"
                    >
                      <IconFileExport size={20} stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>,
                );
              }
            }
          } catch (e) {}
          // In nhãn GHTK: đơn đã đẩy sang GHTK (có mã vận đơn hoặc mã tra cứu)
          if (row.original.attribute77 || sharedLink) {
            actions.push(
              <Tooltip label="In nhãn GHTK" key="print-ghtk-label">
                <ActionIcon
                  variant="light"
                  aria-label="In nhãn GHTK"
                  color="indigo"
                  onClick={() => printGhtkLabel(row.original.orderNumber)}
                >
                  <IconPrinter size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>,
            );
          }
          return <Flex gap={10}>{actions}</Flex>;
        },
      },
    ],
    [location.pathname],
  );

  // Chiều cao vùng cuộn của bảng, để chân bảng sát đáy màn hình
  const [tableHeight, setTableHeight] = useState<number>();

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableRowSelection: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: false,
    enableStickyHeader: true,
    manualPagination: true,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableProps: {
      striped: true,
      highlightOnHover: true,
      withTableBorder: true,
    },
    state: {
      isLoading,
      pagination,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50"],
    },
    paginationDisplayMode: "pages",
    mantineTableContainerProps: {
      style: {
        maxHeight: tableHeight,
        minHeight: tableHeight,
        overflowX: "auto",
        overflowY: "auto",
      },
    },
  });
  useTableFillScreen(table, setTableHeight);

  const modalsConfirmInfo = (orderNumber: string) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận thông tin !</Title>,
      size: "auto",
      children: (
        <ConfirmInfoGHTK orderNumber={orderNumber} onSuccess={fetchData} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleCheckView = React.useCallback(
    async (row: any) => {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        // Kiểm tra nếu orderNumber chứa "DT"
        if (row.original.orderNumber.includes("DT")) {
          navigate("/sell/view-order-return", {
            state: {
              id: row.original.id,
              orderNumber: row.original.orderNumber,
              orderType: row.original.orderType,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        } else {
          navigate("/sell/view-order", {
            state: {
              id: row.original.id,
              orderNumber: row.original.orderNumber,
              orderType: row.original.orderType,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        }
      }
    },
    [navigate],
  );

  // Hàm gọi API lấy danh sách đơn hàng đối tác
  const fetchData = async (exportExcel?: boolean) => {
    setIsLoading(true);
    try {
      const {
        KeySearch,
        OrderNumber,
        Phone,
        FinishDate,
        StartDate,
        EndDate,
        InvId,
        CodeSal,
      } = searchForm.values;
      let url = `/api/v1/CreateSellItem/get-list-return-sale?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}&ShipingVendor=Giao hàng tiết kiệm`;
      const params: string[] = [];
      if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
      if (OrderNumber)
        params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
      if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
      if (FinishDate)
        params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
      if (StartDate) params.push(`StartDate=${StartDate}`);
      if (EndDate) params.push(`EndDate=${EndDate}`);
      if (InvId && InvId.length > 0) params.push(`InvId=${InvId}`);
      if (CodeSal && CodeSal.length > 0)
        params.push(`CodeSal=${encodeURIComponent(CodeSal)}`);
      // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
      if (filterOwDate) {
        const localDate = `${filterOwDate.getFullYear()}-${(
          filterOwDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${filterOwDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        params.push(`OwDate=${localDate}`);
      }
      if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
      if (params.length > 0) {
        url += "&" + params.join("&");
      }
      // Thay đổi endpoint API cho phù hợp với backend của bạn
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        setData(response.data?.pagedList?.lists || []);
        setRowCount(response.totalCount);

        if (exportExcel && !response?.totalCount) {
          NotificationExtension.Fails(
            "Export Excel thất bại, vui lòng liên hệ phòng CNTT !",
          );
        } else if (exportExcel && response?.totalCount > 0) {
          handleExport(response?.totalCount);
        }
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching GHTK orders:", error);
    } finally {
      setIsLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...searchForm.getValues(),
          filterOwDate: filterOwDate,
        }),
      );
    }
  };

  const handleExport = async (totalCount: number) => {
    open();
    try {
      const {
        KeySearch,
        OrderNumber,
        Phone,
        FinishDate,
        StartDate,
        EndDate,
        InvId,
        CodeSal,
      } = searchForm.values;
      let url = `/api/v1/CreateSellItem/get-list-return-sale?Skip=0&Take=${totalCount}&ShipingVendor=Giao hàng tiết kiệm`;
      const params: string[] = [];
      if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
      if (OrderNumber)
        params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
      if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
      if (FinishDate)
        params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
      if (StartDate) params.push(`StartDate=${StartDate}`);
      if (EndDate) params.push(`EndDate=${EndDate}`);
      if (InvId && InvId.length > 0) params.push(`InvId=${InvId}`);
      if (CodeSal && CodeSal.length > 0)
        params.push(`CodeSal=${encodeURIComponent(CodeSal)}`);
      // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
      if (filterOwDate) {
        const localDate = `${filterOwDate.getFullYear()}-${(
          filterOwDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${filterOwDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        params.push(`OwDate=${localDate}`);
      }
      if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
      if (params.length > 0) {
        url += "&" + params.join("&");
      }
      // Thay đổi endpoint API cho phù hợp với backend của bạn
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        const dataAPI = response.data?.pagedList?.lists || [];
        const dataExport = dataAPI.map((i: any) => ({
          "Mã đơn hàng": i.orderNumber || "",
          "Trạng thái đơn hàng":
            orderStatusOptions.find((item) => item.value === i.orderStatus)
              ?.label ||
            i.orderStatus ||
            "",
          "Trạng thái chung": i.attribute12 || "",
          "Trạng thái đẩy đơn":
            i.attribute3 !== "DA_XUAT"
              ? "Chưa đẩy"
              : i.attribute1 &&
                  JSON.parse(i.attribute1) &&
                  JSON.parse(i.attribute1 || {})?.sharedLink
                ? "Đã đẩy"
                : "Không xác định",
          "Trạng thái kho":
            warehouseStatus.find((item) => item.value === i.attribute3)
              ?.label || "Chưa yêu cầu",
          "Ngày xuất kho": i.attribute37
            ? formatDateTransfer(i.attribute37)
            : "",
          "Kho hàng": `[${i.invOrgCode}] ${i.invOrgName}` || "",
          "Nhân viên bán hàng": i.sale || "",
          "Bộ phận giao hàng": i.shipingVendor || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataExport);

        const objectMaxLength: any[] = [];
        dataExport.forEach((row: any) => {
          Object.keys(row).forEach((key, index) => {
            const headerLen = key ? key.toString().length : 0;
            const valueLen = row[key] ? row[key].toString().length : 0;
            const maxLen = Math.max(headerLen, valueLen);

            objectMaxLength[index] = Math.max(
              objectMaxLength[index] || 0,
              maxLen,
            );
          });
        });

        worksheet["!cols"] = objectMaxLength.map((w) => ({ wch: w + 5 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Báo cáo GHTK");
        XLSX.writeFile(workbook, "Bao_cao_GHTK.xlsx");
      }
    } catch (error) {
      console.error("Error fetching GHTK orders:", error);
    } finally {
      close();
    }
  };

  // const handleExport = async () => {
  //   open();
  //   try {
  //     const {
  //       KeySearch,
  //       OrderNumber,
  //       Phone,
  //       FinishDate,
  //       StartDate,
  //       EndDate,
  //       InvId,
  //       CodeSal,
  //     } = searchForm.values;
  //     let url = `/api/v1/CreateSellItem/export-sale-order?Skip=${
  //       pagination?.pageIndex * pagination?.pageSize
  //     }&Take=${pagination.pageSize}&ShipingVendor=Giao hàng tiết kiệm`;
  //     const params: string[] = [];
  //     if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
  //     if (OrderNumber)
  //       params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
  //     if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
  //     if (FinishDate)
  //       params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
  //     if (StartDate) params.push(`StartDate=${StartDate}`);
  //     if (EndDate) params.push(`EndDate=${EndDate}`);
  //     if (InvId && InvId.length > 0) params.push(`InvId=${InvId}`);
  //     if (CodeSal && CodeSal.length > 0)
  //       params.push(`CodeSal=${encodeURIComponent(CodeSal)}`);
  //     // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
  //     if (filterOwDate) {
  //       const localDate = `${filterOwDate.getFullYear()}-${(
  //         filterOwDate.getMonth() + 1
  //       )
  //         .toString()
  //         .padStart(2, "0")}-${filterOwDate
  //         .getDate()
  //         .toString()
  //         .padStart(2, "0")}`;
  //       params.push(`OwDate=${localDate}`);
  //     }
  //     if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
  //     if (params.length > 0) {
  //       url += "&" + params.join("&");
  //     }

  //     const _url = BASE_API_POS + url;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       NotificationExtension.Fails("Export Excel thất bại !");
  //     } else {
  //       const blob = await response.blob();
  //       const urlss = window.URL.createObjectURL(blob);
  //       const _name = new Date().toISOString().slice(0, 10);
  //       let filename = "bao_cao_ghtk.xlsx";
  //       const link = document.createElement("a");
  //       link.href = urlss;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       NotificationExtension.Success("Export Excel thành công !");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     close();
  //   }
  // };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const dataAPI = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.value?.toString(),
        }));

      setDataBranchSelect(dataAPI);
    }
  };

  const fetchDataEmployee = async () => {
    try {
      const res = await repositoryPos.get<MessageResponse<any>>(
        "/api/v1/TblDmEmployee/get-all",
      );
      if (res && res.success) {
        const dataAPI = (res.data || [])
          .filter((item: any) => item?.code)
          .map((item: any) => ({
            value: item.code?.toString(),
            label: `${item.fullname || ""} - ${item.code || ""}`,
          }));
        setDataEmployeeSelect(dataAPI);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setDataEmployeeSelect([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.pageSize, pagination.pageIndex]);

  useEffect(() => {
    fetchDataBranch();
    fetchDataEmployee();
  }, []);

  return (
    <Box mt={10} style={{ overflowX: "hidden" }}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <Grid gutter={8}>
        <Grid.Col span={sizeGrid}>
          <TextInput
            leftSection={<IconSearch color="#15aabf" />}
            placeholder="Từ khoá"
            {...searchForm.getInputProps("KeySearch")}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData();
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            leftSection={<IconCalendarUp color="#15aabf" />}
            placeholder="Ngày bắt đầu"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              searchForm.getValues()?.StartDate &&
              searchForm.getValues()?.StartDate.length > 0
                ? new Date(searchForm.getValues()?.StartDate ?? "")
                : null
            }
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                StartDate: e ? formatDateNotTimeZone(e ?? "") : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            leftSection={<IconCalendarDown color="#15aabf" />}
            placeholder="Ngày kết thúc"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              searchForm.getValues()?.EndDate &&
              searchForm.getValues()?.EndDate.length > 0
                ? new Date(searchForm.getValues()?.EndDate ?? "")
                : null
            }
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                EndDate: e ? formatDateNotTimeZone(e ?? "") : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Chi nhánh"
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataBranchSelect}
            value={
              searchForm.getValues()?.InvId &&
              searchForm.getValues()?.InvId?.length > 0
                ? searchForm.getValues()?.InvId
                : ""
            }
            searchable
            clearable
            nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                InvId: e ? e : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            leftSection={<IconSearch color="#15aabf" />}
            placeholder="Tìm người hưởng số"
            data={dataEmployeeSelect}
            value={
              searchForm.getValues()?.CodeSal &&
              searchForm.getValues()?.CodeSal?.length > 0
                ? searchForm.getValues()?.CodeSal
                : ""
            }
            searchable
            clearable
            nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                CodeSal: e ? e : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <TextInput
            leftSection={<IconFileSearch color="#15aabf" />}
            placeholder="Mã đơn hàng"
            {...searchForm.getInputProps("OrderNumber")}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData();
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <TextInput
            leftSection={<IconNumbers color="#15aabf" />}
            placeholder="Số ĐT khách"
            {...searchForm.getInputProps("Phone")}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData();
            }}
          />
        </Grid.Col>
        {/* <Grid.Col span={sizeGrid}>
            <DatePickerInput
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Thời gian hoàn thành đơn"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...searchForm.getInputProps("FinishDate")}
            />
          </Grid.Col> */}
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Ngày xuất kho"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            clearable
            value={
              filterOwDate && String(filterOwDate)?.length > 0
                ? new Date(filterOwDate)
                : null
            }
            onChange={setFilterOwDate}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Kho hàng"
            leftSection={<IconBuildingWarehouse color="#15aabf" />}
            data={dataBranch}
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            {...searchForm.getInputProps("OrgId")}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Trạng thái đơn hàng"
            data={orderStatusOptions}
            value={filterOrderStatus}
            onChange={(value) => setFilterOrderStatus(value || "")}
            clearable
            searchable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={() => fetchData()}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>
      {/* Nút nằm trên hàng breadcrumb của ListTabGHTK */}
      {toolbar &&
        createPortal(
          <Flex gap={"xs"}>
            <Button
              leftSection={<IconFileExport size={16} />}
              onClick={() => fetchData(true)}
            >
              Export Excel
            </Button>
            <Button
              leftSection={<IconFileExport size={16} />}
              onClick={() => fetchData()}
              loading={isLoading}
            >
              Làm mới
            </Button>
          </Flex>,
          toolbar,
        )}
      <Box mt={20}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default GHTK;
